import React from 'react';

import { AUTO_LOAN_VERTICAL } from 'types/mrph.vertical.constants';
import { AUTO_PURCHASE_LOAN_MODULE } from 'types/morph.pagePosition.constants';
import { formatApr, formatNumberNoDecimals } from 'helpers/number';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { Row } from 'components/Containers/Row/Row';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { useAutoLoanModuleOffers } from './hooks/AutoLoanPurchaseModuleHook';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';

import AutoLoanPurchaseModuleView from './AutoLoanPurchaseModuleView';

const AutoLoanPurchaseModuleController = props => {
  const atr = getViewModuleTrackingAttributes({
    pagePosition: AUTO_PURCHASE_LOAN_MODULE,
    modulePosition: props.modulePosition,
    vertical: AUTO_LOAN_VERTICAL,
  });
  useViewModule(atr);
  const seenPixel = useSeenModulePixel(atr);

  const {
    loadingAutoOffers,
    autoLoanOffer,
    autoLoanAmount,
    autoLoanFormError,
    onChangeAutoLoanHandle,
    onViewOfferDetailsClick,
    onSeeAllOptions,
  } = useAutoLoanModuleOffers();

  let monthlyPayment = '-';
  let apr = '-';
  let productKey = null;
  let hasOffer = false;

  if (!loadingAutoOffers && autoLoanOffer && !autoLoanFormError) {
    monthlyPayment =
      '$' + formatNumberNoDecimals(autoLoanOffer['monthlyPayment']);
    apr = formatApr(autoLoanOffer['apr']);
    productKey = autoLoanOffer['productKey'];
    hasOffer = true;
  }

  // @Todo: move to config on exp normalization
  const autoLoanSectionTooltip = `Monthly payment is an estimate based on your credit profile for a new auto loan 
    with the following terms: 60 month term, ${apr}% APR, ${autoLoanAmount} total car cost`;

  return (
    <SectionContainer>
      <Row>
        <AutoLoanPurchaseModuleView
          autoLoanSectionTooltip={autoLoanSectionTooltip}
          onChangeAutoLoanHandle={onChangeAutoLoanHandle}
          monthlyPayment={monthlyPayment}
          autoLoanAmount={autoLoanAmount}
          productKey={productKey}
          hasOffer={hasOffer}
          autoLoanFormError={autoLoanFormError}
          onViewOfferDetailsClick={onViewOfferDetailsClick}
          onSeeAllOptions={onSeeAllOptions}
          seenPixel={seenPixel}
          datatestid={'autoloan-purchase-module'}
          extraProps={{
            modulePosition: props.modulePosition,
            pagePosition: AUTO_PURCHASE_LOAN_MODULE,
            vertical: AUTO_LOAN_VERTICAL,
          }}
        />
      </Row>
    </SectionContainer>
  );
};

export default AutoLoanPurchaseModuleController;
